/** Updates the VAT-exclusive price whenever Minimog changes the selected variant. */
(() => {
  const formatMoney = (cents, format) => {
    if (typeof window.formatMoney === 'function') return window.formatMoney(cents, format);

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'GBP',
    }).format(cents / 100);
  };

  document.addEventListener('variant:changed', (event) => {
    const variantPrice = Number(event.detail?.variant?.price);
    if (!Number.isFinite(variantPrice)) return;

    const priceExcludingVat = Math.round(variantPrice / 1.2);

    document.querySelectorAll('[data-product-vat-excl]').forEach((container) => {
      const priceElement = container.querySelector('[data-product-vat-excl-price]');
      if (priceElement) priceElement.textContent = formatMoney(priceExcludingVat, container.dataset.moneyFormat);
    });
  });
})();